import React, { Component } from 'react';
import ReactDOM from 'react-dom';
import { Form, Radio } from 'semantic-ui-react';
import { last, first } from 'lodash';

export default class SingleSetFilter extends Component {
    constructor(props) {
        super(props);
        let options = this.props.values;
        if (!options) {
            options = [];
            props.api.forEachNode(node => {
                const cellvalue = this.props.valueGetter(node);
                if (!options.includes(cellvalue) && cellvalue !== null) {
                    options.push(cellvalue);
                }
            });
        }
        this.state = { value: null, options };
    }
    handleChange = (e, { value }) => {
        this.setState({ value }, () => this.props.filterChangedCallback());
    };

    isFilterActive() {
        return (
            this.state.value !== null && this.state.value !== undefined && this.state.value !== ''
        );
    }
    onFloatingFilterChanged(changed) {
        this.setState({ value: null }, () => this.props.filterChangedCallback());
    }
    doesFilterPass({ node }) {
        const cellvalue = this.props.valueGetter(node);
        const radioSelection = this.state.value;
        return cellvalue == radioSelection;
    }

    getModel() {
        return this.state.value ? [this.state.value] : null;
    }

    setModel(model) {
        this.state.value = model ? first(model) : '';
    }

    afterGuiAttached(params) {
        this.focus();
    }

    focus() {
        setTimeout(() => {
            let container = ReactDOM.findDOMNode(this.refs.input);
            if (container) {
                container.focus();
            }
        });
    }

    componentMethod(message) {
        alert(`Alert from PartialMatchFilterComponent ${message}`);
    }

    render() {
        return (
            <Form style={{ padding: '.5rem' }}>
                {this.state.options.map(value => (
                    <Form.Field>
                        <Radio
                            label={value}
                            name="options"
                            value={value}
                            checked={this.state.value === value}
                            onChange={this.handleChange}
                        />
                    </Form.Field>
                ))}
            </Form>
        );
    }
}



// WEBPACK FOOTER //
// ./components/atoms/SingleSetFilter.jsx